import { configureApiEntity } from '../adapter/index';
import { schema } from 'normalizr';

export const productMenuItemsSchema = new schema.Entity('productMenuItems');

export const productMenuItems = configureApiEntity('PRODUCTMENUITEMS', 'productMenuItems', productMenuItemsSchema);
